<template>
<div class="chapter">
<div class="inner_page">
      ﻿
<meta content="text/html; charset=utf-8" http-equiv="Content-Type"/>
<title>
Murder on the Cliffs</title><link href="css/stylesheet.css" rel="stylesheet" type="text/css"/>
<link href="css/page-template.xpgt" rel="stylesheet" type="application/adobe-page-template+xml"/>
<div class="body">
<h1 class="dedication-title"><span class="smallcaps">DEDICATION</span></h1>
<p class="ded2">For Michael O’Regan, my everyday hero, and for three ladies who made it happen: Kim Lionetti, my agent and friend, and Laura Bourgeois and Hope Dellon at St. Martin’s. Thank you.</p>
<p class="ded">Thanks also to April Hearle for her Latin translation.</p></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?0ed04c6e